var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class AlfatronScu61e {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        this.framework = framework;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        // controls
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.firmwareVersion.value;
            }),
            asyncHandlers: [
                {
                    regExp: /VERSION V(.+)/i,
                    callback: (match) => {
                        this.state.firmwareVersion.update(match[1]);
                    },
                },
            ],
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`POW${power ? 'ON' : 'OFF'}`, /POWER (ON|OFF)!/i, tags);
                return match[1].toUpperCase() === 'ON';
            }),
            asyncHandlers: [
                {
                    regExp: /POWER (ON|OFF)!/i,
                    callback: (match) => {
                        this.state.power.update(match[1].toUpperCase() === 'ON');
                    },
                },
            ],
            powerOffRestrictions: ['get'],
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`HDMI${value}`, /HDMI OUT SWITCH TO (\d+)!/i, tags);
                return match[1];
            }),
            asyncHandlers: [
                {
                    regExp: /HDMI OUT SWITCH TO (\d+)!/i,
                    callback: (match) => {
                        this.state.videoMatrixRoutes.update('1', match[1]);
                    },
                },
            ],
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 8000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    yield this.socket.send('STA', /GUI\/RS232 QUERY STATUS!/i, ['poll']);
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            // Configure auto switching.
            yield this.socket.send(`HDMI${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? 'A' : 'M'}`, /HDMI OUT SWITCH TO (?:AUTO|MANUAL) MODE!/i, ['configure']);
            // Get initial states via the STA command. Sometimes not all responses are sent from the STA
            // command. Also, the device seems to hang if we send multiple STA commands back-to-back.
            // So we retry the STA command several times with a timeout.
            const asyncIds = [];
            let power = false;
            const receivedPromises = [
                new Promise((resolve, reject) => {
                    asyncIds.push(this.socket.registerAsync(/POWER (ON|OFF)!/i, (match) => {
                        power = match[1].toUpperCase() === 'ON';
                        resolve();
                    }));
                }),
                new Promise((resolve, reject) => {
                    asyncIds.push(this.socket.registerAsync(/VERSION V(.+)/i, (match) => {
                        this.state.firmwareVersion.update(match[1]);
                        resolve();
                    }));
                }),
                new Promise((resolve, reject) => {
                    asyncIds.push(this.socket.registerAsync(/HDMI OUT SWITCH TO (\d+)!/i, (match) => {
                        this.state.videoMatrixRoutes.update('1', match[1]);
                        resolve();
                    }));
                }),
            ];
            let result = '';
            for (let i = 0; i < 3; i++) {
                yield this.socket.sendAsync(`STA`, ['configure']);
                const timeout = this.timeouts.delay(2000).then(() => 'timeout');
                const responses = Promise.all(receivedPromises).then(() => 'responded');
                result = yield Promise.race([timeout, responses]);
                if (result === 'responded')
                    break;
            }
            asyncIds.forEach(id => this.socket.unregisterAsync(id));
            if (result !== 'responded') {
                this.log.warning(`didn't get all responses from STA command`);
                this.timeouts.set(() => {
                    if (this.framework.phase === 'controlling') {
                        this.framework.changePhase('disconnected');
                    }
                }, 1000);
            }
            this.state.power.update(power);
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    send: 'POWON',
                    next: /POWER (ON|OFF)!/i,
                },
            ], credentials);
        });
    }
}
// static properties
AlfatronScu61e.driverType = 'socketDriver';
AlfatronScu61e.key = '-MwND6WsiByd2LjFPlJr';
AlfatronScu61e.socketOptions = [
    {
        idleTimeoutMs: 0,
        sendTerminator: '.',
        port: 4001,
    },
];
